import { IconX } from "@tabler/icons";
import { useTheme } from "styled-components";

import { Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

interface TableSearchChipProps {
  title: string;
  onClearClick?: () => void;
}

export const TableSearchChip = ({ title, onClearClick }: TableSearchChipProps) => {
  const { colors } = useTheme();
  return (
    <Flex height="2rem" bgColor={colors.grey[400]} padding="0 0.5rem" margin="0.1rem" borderRadius="1rem">
      <Typography title={title} size="0.8rem" padding="0 0.5rem" overflowEllipsis>
        {title}
      </Typography>
      <Flex borderRadius="50%" width="20px" height="20px" bgColor={colors.grey[600]} onClick={onClearClick}>
        <IconX size={15} cursor="pointer" color={colors.common.white} />
      </Flex>
    </Flex>
  );
};
